import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  countdownButton: {
    zIndex: 1000,
    marginBottom: theme.spacing.space12,
    marginTop: 60,
    "@media (orientation: landscape)": {
      margin: 0,
    },
  },
}));
